import React from 'react'
import { Box } from '@mui/material'
import NextImage from 'next/image'
import { EmtTypography, EmtSeparator } from 'emt-components-v2'
import VariantImages from '@/assets/VariantImages'

const AppRatingBox: React.FC = () => (
  <Box
    sx={{
      padding: '17px',
      width: '100%',
      maxWidth: '100%',
      minWidth: '0',
      borderRadius: '16px',
      border: '1px solid #E0E0E0',
      backgroundColor: '#fff',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: '10px',
    }}
  >
    <EmtTypography variant="body1" fontWeight="700">
      L&apos;application de garde française <br />
      la mieux notée :
    </EmtTypography>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '15px', height: '21px' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        <NextImage width={17} height={17} src={VariantImages.AppleIcon} alt="check" />
        <EmtTypography variant="body1" fontWeight="700" color="textSecondary">
          4.6
        </EmtTypography>
      </Box>
      <EmtSeparator sx={{ height: '100%', width: '1px' }} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        <NextImage width={17} height={17} src={VariantImages.TrustPilotIcon} alt="check" />
        <EmtTypography variant="body1" fontWeight="700" color="textSecondary">
          4.6
        </EmtTypography>
      </Box>
      <EmtSeparator sx={{ height: '100%', width: '1px' }} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        <NextImage width={15} height={15} src={VariantImages.PlayStoreIcon} alt="check" />
        <EmtTypography variant="body1" fontWeight="700" color="textSecondary">
          4.5
        </EmtTypography>
      </Box>
    </Box>
  </Box>
)

export default AppRatingBox
